import type { HelpFile } from '../../types/help'
import { HeaderTestIds } from '../../../testids/HeaderTestIds'

export const headerHelp: HelpFile = {
  texts: {
    // User-menu landmark — its accessible name comes from aria-label, the
    // testid is purely for e2e; opt out of contextual help via null.
    [HeaderTestIds.headerUtilityNav]: null,
  },
}
